//Marvel Charecters
const marvelCharecters = [
  {
    id: 1009652,
    name: "Thanos",
    image: "http://i.annihil.us/u/prod/marvel/i/mg/6/40/5274137e3e2cd.jpg",
  },
  {
    id: 1009368,
    image: "http://i.annihil.us/u/prod/marvel/i/mg/9/c0/527bb7b37ff55.jpg",
    name: "Iron Man",
  },
  {
    id: 1009664,
    image: "http://i.annihil.us/u/prod/marvel/i/mg/d/d0/5269657a74350.jpg",
    name: "Thor",
  },

  {
    id: 1009685,
    image: "http://i.annihil.us/u/prod/marvel/i/mg/3/70/5261a838e93c0.jpg",
    name: "Ultron",
  },
  {
    id: 1009718,
    image: "http://i.annihil.us/u/prod/marvel/i/mg/2/60/537bcaef0f6cf.jpg",
    name: "Wolverine",
  },
  // {
  //   id: 1009351,
  //   image: "http://i.annihil.us/u/prod/marvel/i/mg/5/a0/538615ca33ab0.jpg",
  //   name: "Hulk",
  // },
  // {
  //   id: 1010788,
  //   image: "http://i.annihil.us/u/prod/marvel/i/mg/5/50/531773a2ac20a.jpg",
  //   name: "Venom (Mac Gargan)",
  // },
  // {
  //   id: 1009220,
  //   image: "http://i.annihil.us/u/prod/marvel/i/mg/3/50/537ba56d31087.jpg",
  //   name: "Captain America",
  // },
];
//marvel Comics
const marvelComics = [
  {
    id: 49008,
    image: "http://i.annihil.us/u/prod/marvel/i/mg/c/20/53b1be72eec81.jpg",
    title: "100th Anniversary Special (2014) #1",
  },
  {
    id: 67751,
    image: "http://i.annihil.us/u/prod/marvel/i/mg/d/f0/5c78651519390.jpg",
    title: "Avengers By Jason Aaron Vol. 2: World Tour (Trade Paperback)",
  },
  {
    id: 88107,
    image: "http://i.annihil.us/u/prod/marvel/i/mg/3/f0/5e7e699026d31.jpg",
    title: "X-Men: God Loves, Man Kills Extended Cut (2020) #1",
  },
  {
    id: 73549,
    image: "http://i.annihil.us/u/prod/marvel/i/mg/9/50/5c93da653c26b.jpg",
    title: "Deadpool Minibus 3 (Hardcover)",
  },
  {
    id: 51201,
    image: "http://i.annihil.us/u/prod/marvel/i/mg/3/03/5601855c253f1.jpg",
    title: "1602 Witch Hunter Angela (2015) #4",
  },
  // {
  //   id: 52,
  //   image: "http://i.annihil.us/u/prod/marvel/i/mg/5/e0/5841c31f01da8.jpg",
  //   title: "4 (2004) #12",
  // },
  // {
  //   id: 80446,
  //   image: "http://i.annihil.us/u/prod/marvel/i/mg/c/50/5e28b33c9bca6.jpg",
  //   title: "Black Widow: Widowmaker (Trade Paperback)",
  // },
  // {
  //   id: 51966,
  //   image: "http://i.annihil.us/u/prod/marvel/i/mg/3/b0/55351f09088fb.jpg",
  //   title: "Hulk (2014) #15",
  // },
];

export default {
    marvelCharecters,
    marvelComics
}